import { render, staticRenderFns } from "./LeilaoInput.vue?vue&type=template&id=2c442c28"
import script from "./LeilaoInput.vue?vue&type=script&lang=js"
export * from "./LeilaoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports